import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

// 获取浏览器语言设置
function getDefaultLocale() {
  const locale = localStorage.getItem('locale') || navigator.language || 'zh-CN'
  if (locale.includes('zh')) {
    return 'zh-CN'
  }
  return 'en-US'
}

const i18n = createI18n({
  locale: getDefaultLocale(), // 默认语言
  fallbackLocale: 'zh-CN', // 回退语言
  legacy: false, // 使用 Composition API
  globalInjection: true, // 全局注入 $t 函数
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n